/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Not_VerifiedInputs */



/**
* | output |
* | --- |
* | "Email not yet verified. Please check your email and click the verification link." |
*
* @param {Login_Error_Not_VerifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_not_verified = /** @type {((inputs?: Login_Error_Not_VerifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Not_VerifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email pas encore vérifié. Veuillez vérifier votre email et cliquer sur le lien de vérification.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre E-Mail-Adresse ist noch nicht verifiziert. Bitte überprüfen Sie Ihre E-Mails und klicken Sie auf den Bestätigungslink.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email non ancora verificata. Controlla la tua email e clicca sul link di verifica.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Адрес электронной почты еще не подтвержден. Пожалуйста, проверьте свою почту и перейдите по ссылке для подтверждения.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico aún no verificado. Por favor, revise su correo electrónico y haga clic en el enlace de verificación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("邮箱尚未验证。请检查您的邮箱并点击验证链接。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスはまだ確認されていません。メールアドレスを確認し、確認リンクをクリックしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ईमेल अभी तक सत्यापित नहीं हुआ है। कृपया अपना ईमेल जांचें और सत्यापन लिंक पर क्लिक करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail ainda não verificado. Por favor, verifique seu e-mail e clique no link de verificação.")
	return /** @type {LocalizedString} */ ("Email not yet verified. Please check your email and click the verification link.")
});